import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authHeader } from '../../helpers/auth-header';
import { buildUrl } from '../../helpers/Utils';
import axios from 'axios';
import Config from '../../config';
import { getPagingProspectHubSuccess, getPagingProspectHubError } from './actions';
import { GET_PAGING_PROSPECTIVE_HUB } from './types';

const getPagingProspectHubRequest = async query => {
  let url = `${Config.apiServerHost}/api/Client/prospective/hubPaging`;
  return await axios.get(buildUrl(url, query), await authHeader());
};

function* getPagingProspectHub({ payload }) {
  try {
    const response = yield call(getPagingProspectHubRequest, payload);
    yield put(getPagingProspectHubSuccess(response.data));
  } catch (error) {
    yield put(getPagingProspectHubError(error));
  }
}

export default function* rootSaga() {
  yield takeEvery(GET_PAGING_PROSPECTIVE_HUB, getPagingProspectHub);
}
